module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dropzone-area",
    attrs: {
      "drag-over": "handleDragOver"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropzone-text"
  }, [_c('span', {
    staticClass: "dropzone-title"
  }, [_vm._v("Drop Sketch 43 file here or click to select")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03256728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropzone.vue
// module id = 117
// module chunks = 1